import React, { useEffect, useState } from "react";
import { RiverSensor } from "./RiverSensors";

interface Props {
  sendNewRiverData: (data: any) => void;
  setSharedString: (value: string) => void;
}

const AvailableRiverSensors: React.FC<Props> = ({
  sendNewRiverData,
  setSharedString,
}) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [riverSensorList, setRiverSensors] = useState<RiverSensor[]>([]);
  const [sensorNames, setSensorNames] = useState<string[]>([]);
  const [sensorMap, setSensorMap] = useState<{ [id: string]: string }>({});

  const handleCheckboxChange = (sensorName: string) => {
    const newSelected = selected.includes(sensorName)
      ? selected.filter((name) => name !== sensorName)
      : [...selected, sensorName];

    setSelected(newSelected);
    setSharedString(sensorName);

    const sensorId = Object.keys(sensorMap).find(
      (key) => sensorMap[key] === sensorName
    );
    if (sensorId && newSelected.includes(sensorName)) {
      fetchDataAndInitializeChart(sensorId);
    }
  };
  useEffect(() => {
    const fetchCurrentSensorsData = async () => {
      const RIVER_LEVEL_URL =
      process.env.REACT_APP_RIVER_LEVEL_URL;
      try {
        const response = await fetch(
          `${RIVER_LEVEL_URL}`
        );
        const responseData = await response.json();

        if (Array.isArray(responseData)) {
          const data: RiverSensor[] = responseData;
          setRiverSensors(data);

          const names = data.map((sensor) => sensor.name);
          setSensorNames(names);

          const map: { [id: string]: string } = {};
          data.forEach((sensor) => {
            map[sensor.id] = sensor.name;
          });
          setSensorMap(map);
        } else {
          console.error("Invalid response data format:", responseData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCurrentSensorsData();
  }, []);

  const fetchDataAndInitializeChart = async (id: string) => {
    const RIVER_LEVEL_THREE_DAYS_URL =
    process.env.REACT_APP_RIVER_LEVEL_THREE_DAYS_URL;
    try {
      const response = await fetch(
        `${RIVER_LEVEL_THREE_DAYS_URL}` +
          id
      );
      const responseData = await response.json();

      if (responseData && Array.isArray(responseData.results)) {
        const data = responseData.results.map((item: any) => [
          item.timestamp,
          item.value,
        ]);
        sendNewRiverData(data);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
            
                            <div className={`sideMenu2DataContainer`}>
                                {/* Layer items */}
                                {sensorNames.map((gauge, index) => (
                                    <div key={index} className={`layerItem`}>
                                        <span>{gauge}</span>
                                        <input type="checkbox" onChange={() => handleCheckboxChange(gauge)}/>
                                    </div>
                                ))}
                            </div>
    
    </>
    // <div style={{ zIndex: 10 }}>
    //   <div
    //     style={{
    //       position: "absolute",
    //       right: "10px",
    //       top: "200px",
    //       transform: "translateY(-50%)",
    //       backgroundColor: "rgba(85, 84, 95, 0.9)",
    //       padding: "10px",
    //       borderRadius: "5px",
    //       width: "320px",
    //       height: "220px",
    //       overflowY: "auto",
    //     }}
    //   >
    //     <div style={{ display: "flex", justifyContent: "flex-end" }}>
    //       <FontAwesomeIcon
    //         onClick={onClose}
    //         style={{
    //           cursor: "pointer",
    //           color: "red",
    //         }}
    //         icon={faClose}
    //       />
    //     </div>
    //     <div
    //       style={{
    //         height: "100%",
    //         margin: "5px 0",
    //         display: "flex",
    //         flexDirection: "column",
    //         borderRadius: "2px",
    //         padding: "5px",
    //       }}
    //     >
    //       {sensorNames.map((name) => (
    //         <div
    //           key={name}
    //           style={{
    //             display: "flex",
    //             alignItems: "flex-start", // Align items to the start of the row
    //             marginBottom: "5px",
    //           }}
    //         >
    //           <Checkbox
    //             checked={selected.includes(name)}
    //             onChange={() => handleCheckboxChange(name)}
    //             sx={{
    //               color: "white",
    //               "&.Mui-checked": {
    //                 color: "white",
    //               },
    //               padding: 0, // Remove extra padding
    //             }}
    //           />
    //           <span
    //             style={{
    //               color: "white",
    //               fontSize: "12px",
    //               // fontWeight: "bold",
    //               marginLeft: "8px",
    //               marginTop: "5px", // Adjust margin to control spacing
    //               padding: 0,
    //             }}
    //           >
    //             {name}
    //           </span>
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // </div>
  );
};

export default AvailableRiverSensors;
